import React, { ReactNode, useCallback, useEffect, useState } from "react";

import { faAngleUp } from "@fortawesome/pro-solid-svg-icons/faAngleUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
import cn from "classnames";

import { isDefined } from "@mapmycustomers/shared";

import Button from "../Button";

import { Alert, AlertProps } from "./index";

const block = bem("mmc-collapsible-alert");

export interface CollapsibleAlertProps extends Omit<
  AlertProps,
  "action" | "description" | "message"
> {
  defaultOpen?: boolean;
  description: ReactNode;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  title: ReactNode;
}

export const CollapsibleAlert = ({
  className,
  defaultOpen,
  description,
  onOpenChange,
  open,
  title,
  ...props
}: CollapsibleAlertProps) => {
  const [internalOpen, setInternalOpen] = useState(open ?? defaultOpen ?? true);
  useEffect(() => {
    if (isDefined(open)) {
      setInternalOpen(open);
    }
  }, [open]);

  const handleToggleClick = useCallback(() => {
    setInternalOpen((open) => {
      if (onOpenChange) {
        onOpenChange(!open);
        return open;
      } else {
        return !open;
      }
    });
  }, [onOpenChange]);

  return (
    <Alert
      action={
        <Button
          icon={<FontAwesomeIcon icon={faAngleUp} rotation={internalOpen ? undefined : 180} />}
          iconOnly
          onClick={handleToggleClick}
          size="small"
          type="control"
        />
      }
      className={cn(block(), className)}
      description={internalOpen ? description : undefined}
      message={title}
      {...props}
    />
  );
};
